import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PhotoGridViewerActionButton from '../../../../../../../../../../../components/grid/components/PhotoGridViewerActionButton';
import DownloadIcon from '../../../../../../../../../../../components/icons/DownloadIcon';
import TrashIcon from '../../../../../../../../../../../components/icons/TrashIcon';
import usePhotoDownload from '../../../../../../../../../../../hooks/usePhotoDownload';
import { ALBUM_PHOTO_STATUS } from '../../../../../../../../../../../constants/albums';
import EyeSlashIcon from '../../../../../../../../../../../components/icons/EyeSlashIcon';
import { isMobile } from '../../../../../../../../../../../util/device-detector';
import useRequestConfirm from '../../../../../../../../../../../hooks/useRequestConfirm';
import EyeIcon from '../../../../../../../../../../../components/icons/EyeIcon';
import { NoContributorPermissionBlock } from '../../../../../../../../../services/contributors';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    is_album_slideshow_photo: PropTypes.bool,
    album_oauth_link_photo_exists: PropTypes.bool,
  }).isRequired,
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func,
  onVisibilityToggle: PropTypes.func,
};

const SlideshowDesignerPhotoViewerActions = ({
  album,
  photo,
  onDelete,
  onVisibilityToggle,
}) => {
  const requestConfirm = useRequestConfirm();
  const { handleDownload, loading: loadingDownload } = usePhotoDownload({
    photoId: photo.id,
  });
  const isPublished =
    photo?.album_photo_status === ALBUM_PHOTO_STATUS.PUBLISHED;

  return (
    <Fragment>
      <PhotoGridViewerActionButton
        label="Download Photo"
        icon={<DownloadIcon />}
        onClick={handleDownload}
        disabled={loadingDownload}
        className={classNames({
          'is-loading': loadingDownload,
        })}
      />

      <NoContributorPermissionBlock entityId={album.id}>
        {onVisibilityToggle && photo && (
          <PhotoGridViewerActionButton
            label={
              isPublished
                ? 'Hide'
                : 'Photo is hidden from others. Click to unhide.'
            }
            className={!isPublished ? 'text-danger' : ''}
            icon={isPublished ? <EyeIcon /> : <EyeSlashIcon color="#fe5851" />}
            onClick={() => {
              if (isMobile()) {
                requestConfirm({
                  message: (
                    <>
                      <h3 className="text-center">
                        Are you sure you want to{' '}
                        {isPublished ? 'hide' : 'publish'} this photo?
                      </h3>
                    </>
                  ),
                  confirmText: isPublished ? 'Hide' : 'Publish',
                  cancelText: 'Go back',
                  onConfirm: onVisibilityToggle,
                  onCancel: () => {},
                });
              } else {
                onVisibilityToggle();
              }
            }}
          />
        )}

        {onDelete && (
          <PhotoGridViewerActionButton
            label="Delete"
            icon={<TrashIcon />}
            onClick={onDelete}
          />
        )}
      </NoContributorPermissionBlock>
    </Fragment>
  );
};

SlideshowDesignerPhotoViewerActions.propTypes = propTypes;

export default SlideshowDesignerPhotoViewerActions;
